import { Link } from "react-router-dom";
import { fr } from "../i18n/fr";
import { Panel, Button } from "../components/ui";
import { EtheriaMark } from "../components/layout/Logo";

/** 404 — chemin introuvable, stylé au thème. */
export function NotFound() {
  return (
    <div className="content-layer mx-auto max-w-xl px-4 py-24 text-center">
      <Panel rivets glow="ember" className="p-12">
        <EtheriaMark className="mx-auto h-16 w-16 opacity-60" />
        <p className="mt-4 font-mono text-5xl text-ember-300">404</p>
        <h1 className="mt-2 font-display text-2xl text-parchment-100">{fr.errors.pageIntrouvable}</h1>
        <p className="mt-2 text-sm text-parchment-200/55">{fr.errors.pageIntrouvableDesc}</p>
        <div className="mt-6">
          <Link to="/">
            <Button variant="primary">{fr.errors.retourAccueil}</Button>
          </Link>
        </div>
      </Panel>
    </div>
  );
}
